<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="当前市场价格：">
                <span class="color_red">{{ max_bidding_price }}元</span>
            </el-form-item>
            <el-form-item label="我的报价：" prop="quoted_price">
                <el-input placeholder="请输入报价..." v-model.number="ruleForm.quoted_price">
                    <template slot="append">
                        <span class="color_red">元</span>
                    </template>
                </el-input>
            </el-form-item>
        </el-form>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '竞价',
            max_bidding_price: '',
            ruleForm: {
                recruitment_id: '',
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                // "audit_state": "",
                quoted_price: null,
            },
            options: JSON.parse(localStorage.getItem('entinfolist')),
            rules: {
                outline_name: [
                    { required: true, message: '请输入课程名称', trigger: 'blur' },

                ],
                enterprise_id: [
                    { required: true, message: '请选择所属企业', trigger: 'change' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        init(data) {

            this.max_bidding_price = data.max_bidding_price
            this.ruleForm = {
                recruitment_id: data.recruitment_id,
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                // "audit_state": "",
                quoted_price: data.quoted_price,

            }
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {


                    let obj = {
                        ...this.ruleForm,

                    }

                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.biddingApplicationAdd, {
                            data: obj
                        }).then((res) => {
                            if (res.data.code == 0) {
                                // this.okFn(res.data.data.id)
                                this.$message({ type: "success", message: '竞价成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 测试生成未投放接口
        okFn(id) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.testAfterPay, {
                    data: {
                        id
                    }
                }).then((res) => {
                    if (res.data.code == 0) {

                        this.$message({ type: "success", message: '竞价成功' });
                        this.$emit('ok')
                        this.dialogVisible = false


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                }).catch((err) => {
                    // this.loading = false; 
                });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.ruleForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped></style>